import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Personal } from "../../Personal/Personal";
import { PuestosTrabajo } from "../../PuestosTrabajo/PuestosTrabajo";

const columns = () =>
(
    {
        vc_personales: new EntityColumn<string[]>({ name: 'vc_personales', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal asignado', isArray: true }),
        vc_puestos: new EntityColumn<string[]>({ name: 'vc_puestos', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Puestos', isArray: true }),
        ...DefaultColumns()
    }
)

const lookups = () =>
(
    {
        'Personal': {
            name: 'Personal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },
        'Puestos': {
            name: 'Puestos',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new PuestosTrabajo(client, parentKeys)
        },
    }
)

export class SolicitudesRuteoInfoFiltersDef extends EntityDefinition {

    columns = columns();
    views = {};
    lookups = lookups();

    constructor() {
        super('SolicitudesRuteoInfoFilters');
    }
}